import {
  Companion_getInstance11rxtahezlto7 as Companion_getInstance,
  Specification3fgfbf7ihgj8v as Specification,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  UUID21wrnrlmk5y1y as UUID,
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
} from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  SpecViewgfdgv6h7w5ti as SpecView,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
} from './supportModels.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  KtList3hktaavzmj137 as KtList,
  KtSetjrjc7fhfd6b9 as KtSet,
} from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_contractor(_this__u8e3s4) {
  return _this__u8e3s4.prop(Specification_contractor_getInstance());
}
function get_unit(_this__u8e3s4) {
  return _this__u8e3s4.prop(Specification_unit_getInstance());
}
function get__id(_this__u8e3s4) {
  return _this__u8e3s4.prop(Specification__id_getInstance());
}
function get_group(_this__u8e3s4) {
  return _this__u8e3s4.prop(Specification_group_getInstance());
}
function prepareSpecificationFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [Specification__id_getInstance(), Specification_contractor_getInstance(), Specification_group_getInstance(), Specification_title_getInstance(), Specification_description_getInstance(), Specification_price_getInstance(), Specification_unit_getInstance(), Specification_files_getInstance(), Specification_readBy_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function Specification_contractor$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function Specification_contractor$_get_name_$ref_51wx4y() {
  return (p0) => p0.k20();
}
function Specification_contractor$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Specification_contractor$_get_serializer_$ref_m88gm3() {
  return (p0) => p0.j2j();
}
function Specification_contractor$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function Specification_contractor$_get_annotations_$ref_xpkqq1() {
  return (p0) => p0.bz();
}
var Specification_contractorClass;
function Specification_contractor() {
  if (Specification_contractorClass === VOID) {
    class $ {
      constructor() {
        Specification_contractor_instance = this;
        var tmp = this;
        tmp.q83_1 = lazy(Specification_contractor$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.r83_1 = lazy(Specification_contractor$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.s83_1 = lazy(Specification_contractor$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.q83_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Specification_contractor$_get_name_$ref_51wx4y(), null);
        return tmp0.f2();
      }
      t83(receiver) {
        return receiver.v83_1;
      }
      m2j(receiver) {
        return this.t83(receiver instanceof Specification() ? receiver : THROW_CCE());
      }
      d84(receiver, value) {
        return receiver.e84(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Specification() ? receiver : THROW_CCE();
        return this.d84(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.r83_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Specification_contractor$_get_serializer_$ref_m88gm3(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.s83_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Specification_contractor$_get_annotations_$ref_xpkqq1(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Specification_contractor', VOID, VOID, [SerializableProperty()]);
    Specification_contractorClass = $;
  }
  return Specification_contractorClass;
}
var Specification_contractor_instance;
function Specification_contractor_getInstance() {
  if (Specification_contractor_instance === VOID)
    new (Specification_contractor())();
  return Specification_contractor_instance;
}
function Specification_unit$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(6);
}
function Specification_unit$_get_name_$ref_uuxwib() {
  return (p0) => p0.k20();
}
function Specification_unit$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Specification_unit$_get_serializer_$ref_7t0fvw() {
  return (p0) => p0.j2j();
}
function Specification_unit$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(6);
}
function Specification_unit$_get_annotations_$ref_cscg0o() {
  return (p0) => p0.bz();
}
var Specification_unitClass;
function Specification_unit() {
  if (Specification_unitClass === VOID) {
    class $ {
      constructor() {
        Specification_unit_instance = this;
        var tmp = this;
        tmp.f84_1 = lazy(Specification_unit$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.g84_1 = lazy(Specification_unit$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.h84_1 = lazy(Specification_unit$annotations$delegate$lambda);
        this.i84_1 = null;
        this.j84_1 = 'null';
      }
      k20() {
        var tmp0 = this.f84_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Specification_unit$_get_name_$ref_uuxwib(), null);
        return tmp0.f2();
      }
      t83(receiver) {
        return receiver.a84_1;
      }
      m2j(receiver) {
        return this.t83(receiver instanceof Specification() ? receiver : THROW_CCE());
      }
      k84(receiver, value) {
        return receiver.e84(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Specification() ? receiver : THROW_CCE();
        return this.k84(tmp, (value == null ? true : typeof value === 'string') ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.g84_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Specification_unit$_get_serializer_$ref_7t0fvw(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.h84_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Specification_unit$_get_annotations_$ref_cscg0o(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Specification_unit', VOID, VOID, [SerializableProperty()]);
    Specification_unitClass = $;
  }
  return Specification_unitClass;
}
var Specification_unit_instance;
function Specification_unit_getInstance() {
  if (Specification_unit_instance === VOID)
    new (Specification_unit())();
  return Specification_unit_instance;
}
function Specification__id$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function Specification__id$_get_name_$ref_271dzp() {
  return (p0) => p0.k20();
}
function Specification__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Specification__id$_get_serializer_$ref_iuqtaq() {
  return (p0) => p0.j2j();
}
function Specification__id$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function Specification__id$_get_annotations_$ref_wbvuy2() {
  return (p0) => p0.bz();
}
var Specification__idClass;
function Specification__id() {
  if (Specification__idClass === VOID) {
    class $ {
      constructor() {
        Specification__id_instance = this;
        var tmp = this;
        tmp.l84_1 = lazy(Specification__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.m84_1 = lazy(Specification__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.n84_1 = lazy(Specification__id$annotations$delegate$lambda);
        this.o84_1 = Companion_getInstance_0().m2p();
        this.p84_1 = 'UUID.random()';
      }
      k20() {
        var tmp0 = this.l84_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Specification__id$_get_name_$ref_271dzp(), null);
        return tmp0.f2();
      }
      t83(receiver) {
        return receiver.u83_1;
      }
      m2j(receiver) {
        return this.t83(receiver instanceof Specification() ? receiver : THROW_CCE());
      }
      d84(receiver, value) {
        return receiver.e84(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Specification() ? receiver : THROW_CCE();
        return this.d84(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.m84_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Specification__id$_get_serializer_$ref_iuqtaq(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.n84_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Specification__id$_get_annotations_$ref_wbvuy2(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Specification__id', VOID, VOID, [SerializableProperty()]);
    Specification__idClass = $;
  }
  return Specification__idClass;
}
var Specification__id_instance;
function Specification__id_getInstance() {
  if (Specification__id_instance === VOID)
    new (Specification__id())();
  return Specification__id_instance;
}
function Specification_group$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function Specification_group$_get_name_$ref_ea1ky8() {
  return (p0) => p0.k20();
}
function Specification_group$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Specification_group$_get_serializer_$ref_55sf49() {
  return (p0) => p0.j2j();
}
function Specification_group$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function Specification_group$_get_annotations_$ref_1tju6z() {
  return (p0) => p0.bz();
}
var Specification_groupClass;
function Specification_group() {
  if (Specification_groupClass === VOID) {
    class $ {
      constructor() {
        Specification_group_instance = this;
        var tmp = this;
        tmp.q84_1 = lazy(Specification_group$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.r84_1 = lazy(Specification_group$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.s84_1 = lazy(Specification_group$annotations$delegate$lambda);
        this.t84_1 = null;
        this.u84_1 = 'null';
      }
      k20() {
        var tmp0 = this.q84_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Specification_group$_get_name_$ref_ea1ky8(), null);
        return tmp0.f2();
      }
      t83(receiver) {
        return receiver.w83_1;
      }
      m2j(receiver) {
        return this.t83(receiver instanceof Specification() ? receiver : THROW_CCE());
      }
      v84(receiver, value) {
        return receiver.e84(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Specification() ? receiver : THROW_CCE();
        return this.v84(tmp, (value == null ? true : value instanceof SpecView()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.r84_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Specification_group$_get_serializer_$ref_55sf49(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.s84_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Specification_group$_get_annotations_$ref_1tju6z(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Specification_group', VOID, VOID, [SerializableProperty()]);
    Specification_groupClass = $;
  }
  return Specification_groupClass;
}
var Specification_group_instance;
function Specification_group_getInstance() {
  if (Specification_group_instance === VOID)
    new (Specification_group())();
  return Specification_group_instance;
}
function Specification_title$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(3);
}
function Specification_title$_get_name_$ref_pf7lft() {
  return (p0) => p0.k20();
}
function Specification_title$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Specification_title$_get_serializer_$ref_3qmrf4() {
  return (p0) => p0.j2j();
}
function Specification_title$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(3);
}
function Specification_title$_get_annotations_$ref_ssshis() {
  return (p0) => p0.bz();
}
var Specification_titleClass;
function Specification_title() {
  if (Specification_titleClass === VOID) {
    class $ {
      constructor() {
        Specification_title_instance = this;
        var tmp = this;
        tmp.w84_1 = lazy(Specification_title$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.x84_1 = lazy(Specification_title$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.y84_1 = lazy(Specification_title$annotations$delegate$lambda);
        this.z84_1 = '';
        this.a85_1 = '""';
      }
      k20() {
        var tmp0 = this.w84_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Specification_title$_get_name_$ref_pf7lft(), null);
        return tmp0.f2();
      }
      t83(receiver) {
        return receiver.x83_1;
      }
      m2j(receiver) {
        return this.t83(receiver instanceof Specification() ? receiver : THROW_CCE());
      }
      b85(receiver, value) {
        return receiver.e84(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Specification() ? receiver : THROW_CCE();
        return this.b85(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.x84_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Specification_title$_get_serializer_$ref_3qmrf4(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.y84_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Specification_title$_get_annotations_$ref_ssshis(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Specification_title', VOID, VOID, [SerializableProperty()]);
    Specification_titleClass = $;
  }
  return Specification_titleClass;
}
var Specification_title_instance;
function Specification_title_getInstance() {
  if (Specification_title_instance === VOID)
    new (Specification_title())();
  return Specification_title_instance;
}
function Specification_description$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(4);
}
function Specification_description$_get_name_$ref_hvq831() {
  return (p0) => p0.k20();
}
function Specification_description$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Specification_description$_get_serializer_$ref_hr1uzw() {
  return (p0) => p0.j2j();
}
function Specification_description$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(4);
}
function Specification_description$_get_annotations_$ref_y1ztew() {
  return (p0) => p0.bz();
}
var Specification_descriptionClass;
function Specification_description() {
  if (Specification_descriptionClass === VOID) {
    class $ {
      constructor() {
        Specification_description_instance = this;
        var tmp = this;
        tmp.c85_1 = lazy(Specification_description$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.d85_1 = lazy(Specification_description$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.e85_1 = lazy(Specification_description$annotations$delegate$lambda);
        this.f85_1 = '';
        this.g85_1 = '""';
      }
      k20() {
        var tmp0 = this.c85_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Specification_description$_get_name_$ref_hvq831(), null);
        return tmp0.f2();
      }
      t83(receiver) {
        return receiver.y83_1;
      }
      m2j(receiver) {
        return this.t83(receiver instanceof Specification() ? receiver : THROW_CCE());
      }
      b85(receiver, value) {
        return receiver.e84(VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Specification() ? receiver : THROW_CCE();
        return this.b85(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.d85_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Specification_description$_get_serializer_$ref_hr1uzw(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.e85_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Specification_description$_get_annotations_$ref_y1ztew(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Specification_description', VOID, VOID, [SerializableProperty()]);
    Specification_descriptionClass = $;
  }
  return Specification_descriptionClass;
}
var Specification_description_instance;
function Specification_description_getInstance() {
  if (Specification_description_instance === VOID)
    new (Specification_description())();
  return Specification_description_instance;
}
function Specification_price$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(5);
}
function Specification_price$_get_name_$ref_21y8uy() {
  return (p0) => p0.k20();
}
function Specification_price$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Specification_price$_get_serializer_$ref_gn0wlb() {
  return (p0) => p0.j2j();
}
function Specification_price$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(5);
}
function Specification_price$_get_annotations_$ref_2iam05() {
  return (p0) => p0.bz();
}
var Specification_priceClass;
function Specification_price() {
  if (Specification_priceClass === VOID) {
    class $ {
      constructor() {
        Specification_price_instance = this;
        var tmp = this;
        tmp.h85_1 = lazy(Specification_price$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.i85_1 = lazy(Specification_price$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.j85_1 = lazy(Specification_price$annotations$delegate$lambda);
        this.k85_1 = null;
        this.l85_1 = 'null';
      }
      k20() {
        var tmp0 = this.h85_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Specification_price$_get_name_$ref_21y8uy(), null);
        return tmp0.f2();
      }
      m85(receiver) {
        return receiver.z83_1;
      }
      m2j(receiver) {
        var tmp = this.m85(receiver instanceof Specification() ? receiver : THROW_CCE());
        return tmp == null ? null : new (MonetaryValue())(tmp);
      }
      n85(receiver, value) {
        return receiver.e84(VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Specification() ? receiver : THROW_CCE();
        var tmp_0;
        if (value == null ? true : value instanceof MonetaryValue()) {
          var tmp_1 = value;
          tmp_0 = tmp_1 == null ? null : tmp_1.a5s_1;
        } else {
          tmp_0 = THROW_CCE();
        }
        return this.n85(tmp, tmp_0);
      }
      j2j() {
        var tmp0 = this.i85_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Specification_price$_get_serializer_$ref_gn0wlb(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.j85_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Specification_price$_get_annotations_$ref_2iam05(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Specification_price', VOID, VOID, [SerializableProperty()]);
    Specification_priceClass = $;
  }
  return Specification_priceClass;
}
var Specification_price_instance;
function Specification_price_getInstance() {
  if (Specification_price_instance === VOID)
    new (Specification_price())();
  return Specification_price_instance;
}
function Specification_files$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(7);
}
function Specification_files$_get_name_$ref_2owll4() {
  return (p0) => p0.k20();
}
function Specification_files$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Specification_files$_get_serializer_$ref_spunip() {
  return (p0) => p0.j2j();
}
function Specification_files$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(7);
}
function Specification_files$_get_annotations_$ref_lscivn() {
  return (p0) => p0.bz();
}
var Specification_filesClass;
function Specification_files() {
  if (Specification_filesClass === VOID) {
    class $ {
      constructor() {
        Specification_files_instance = this;
        var tmp = this;
        tmp.o85_1 = lazy(Specification_files$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.p85_1 = lazy(Specification_files$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.q85_1 = lazy(Specification_files$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'kotlin.collections.listOf' call
        tmp_2.r85_1 = emptyList();
        this.s85_1 = 'listOf()';
      }
      k20() {
        var tmp0 = this.o85_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Specification_files$_get_name_$ref_2owll4(), null);
        return tmp0.f2();
      }
      t83(receiver) {
        return receiver.b84_1;
      }
      m2j(receiver) {
        return this.t83(receiver instanceof Specification() ? receiver : THROW_CCE());
      }
      t85(receiver, value) {
        return receiver.e84(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Specification() ? receiver : THROW_CCE();
        return this.t85(tmp, (!(value == null) ? isInterface(value, KtList()) : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.p85_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Specification_files$_get_serializer_$ref_spunip(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.q85_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Specification_files$_get_annotations_$ref_lscivn(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Specification_files', VOID, VOID, [SerializableProperty()]);
    Specification_filesClass = $;
  }
  return Specification_filesClass;
}
var Specification_files_instance;
function Specification_files_getInstance() {
  if (Specification_files_instance === VOID)
    new (Specification_files())();
  return Specification_files_instance;
}
function Specification_readBy$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(8);
}
function Specification_readBy$_get_name_$ref_wc5geu() {
  return (p0) => p0.k20();
}
function Specification_readBy$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[8];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Specification_readBy$_get_serializer_$ref_v8222l() {
  return (p0) => p0.j2j();
}
function Specification_readBy$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(8);
}
function Specification_readBy$_get_annotations_$ref_ae3wwx() {
  return (p0) => p0.bz();
}
var Specification_readByClass;
function Specification_readBy() {
  if (Specification_readByClass === VOID) {
    class $ {
      constructor() {
        Specification_readBy_instance = this;
        var tmp = this;
        tmp.u85_1 = lazy(Specification_readBy$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.v85_1 = lazy(Specification_readBy$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.w85_1 = lazy(Specification_readBy$annotations$delegate$lambda);
        this.x85_1 = emptySet();
        this.y85_1 = 'emptySet()';
      }
      k20() {
        var tmp0 = this.u85_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Specification_readBy$_get_name_$ref_wc5geu(), null);
        return tmp0.f2();
      }
      t83(receiver) {
        return receiver.c84_1;
      }
      m2j(receiver) {
        return this.t83(receiver instanceof Specification() ? receiver : THROW_CCE());
      }
      z85(receiver, value) {
        return receiver.e84(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Specification() ? receiver : THROW_CCE();
        return this.z85(tmp, (!(value == null) ? isInterface(value, KtSet()) : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.v85_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Specification_readBy$_get_serializer_$ref_v8222l(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.w85_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Specification_readBy$_get_annotations_$ref_ae3wwx(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Specification_readBy', VOID, VOID, [SerializableProperty()]);
    Specification_readByClass = $;
  }
  return Specification_readByClass;
}
var Specification_readBy_instance;
function Specification_readBy_getInstance() {
  if (Specification_readBy_instance === VOID)
    new (Specification_readBy())();
  return Specification_readBy_instance;
}
//region block: exports
export {
  get__id as get__id1jb1ank0whnwb,
  get_contractor as get_contractorko2ied3oyiyr,
  get_group as get_group3r0mzizyuszin,
  prepareSpecificationFields as prepareSpecificationFields1zah77c13djk7,
  get_unit as get_unitn13b4k6xyo8x,
};
//endregion

//# sourceMappingURL=SpecificationFields.mjs.map
